import { Bundle } from '../../../api/src/bundles/bundle.entity'
import styles from './bundleActions.module.css'
import ButtonSet from 'components/Button/ButtonSet'
import LinkButton from 'components/LinkButton'
import Button from 'components/Button'
import { useRouter } from 'next/router'
import { createTempUser } from 'modules/User/remote'
import { addBundleToCart } from 'modules/Orders/remote'
import { isSuccessful } from 'utilities/api'
import { isUndefined } from 'lodash'
import { mapObject } from 'utilities/object'
import { toString } from 'lodash'
import { pickBy } from 'lodash'

type Props = {
  bundle: Bundle,
  limitToOccasionIds?: number[],
  suppressLink?: boolean,
  receiverId?: number,
}

const BundleActions = ({ bundle, limitToOccasionIds, suppressLink = false, receiverId }: Props) => {
  const router = useRouter()
  const getQueryString = (isCustomizing: boolean, limitToOccasionIds?: number[]) => {
    // console.log('get query string', isCustomizing, limitToOccasionIds, receiverId)
    const queryParams = {
      isCustomizing,
      receiverId,
      categoryIds: limitToOccasionIds?.join(','),
    }
    // console.log({ queryParams })
    const queryParamsWithStringValues = mapObject(queryParams, ([key, value]) => {
      const valueAsString = !!value ? toString(value) : undefined
      return [key, valueAsString]
    })
    const filteredQueryParams = pickBy(queryParamsWithStringValues, (value) => !isUndefined(value)) as Record<string, string>

    // const isCustomizingQueryString = isCustomizing ? 'isCustomizing' : ''
    // const categoryIdsQueryString = isUndefined(limitToOccasionIds)
    //   ? ''
    //   : `categoryIds=${limitToOccasionIds.join(',')}`
    // const receiverIdQueryString = receiverId ? `receiverId=${receiverId}` : ''
    const urlSearchParams = new URLSearchParams(filteredQueryParams)
    const queryParamsString = urlSearchParams.toString()
    console.log({ queryParamsString })
    return `?${ queryParamsString }`


    // if (isCustomizingQueryString) {
    //   return categoryIdsQueryString
    //     ? `?${isCustomizingQueryString}&${categoryIdsQueryString}`
    //     : `?${isCustomizingQueryString}`
    // }
    // return categoryIdsQueryString
    // ? `?${categoryIdsQueryString}`
    // : ''
  }

  // const handleViewDetails = (slug: string, isCustomizing = false) => {
  //   const queryString = getQueryString(isCustomizing, limitToOccasionIds)
  //   router.push(`/bundles/${slug}${queryString}`)
  // }
  const handleBuyAsIs = async (bundleId: number) => {
    await createTempUser()
    const result = await addBundleToCart({ bundleId, limitToOccasionIds })
    if (isSuccessful(result)) {
      router.push('/checkout')
    }
  }
  const variant = suppressLink ? 'small' : 'tiny'

  return <div className={styles.bundleActions}>
  <ButtonSet alignment='flex-start'>
    { !suppressLink &&
      <LinkButton
        className={styles.bundleActionButton}
        variant='tiny'
        color='blue'
        href={`/bundles/${bundle.slug}`}
      >View details &raquo;</LinkButton>
    }
    <Button
      className={styles.bundleActionButton}
      variant={variant}
      color='blue'
      isSecondary
      onClick={ (e) => {
        e?.stopPropagation()
        handleBuyAsIs(bundle.id)
      } }
    >Buy as is &raquo;</Button>
    <LinkButton
      className={styles.bundleActionButton}
      variant={variant}
      color='blue'
      isSecondary={!suppressLink}
      href={`/bundles/${bundle.slug}${getQueryString(true, limitToOccasionIds)}`}
      // onClick={ (e) => {
      //   e?.stopPropagation()
      //   e?.cancelBubble
      //   handleViewDetails(bundle.slug, true)
      // } }
    >Customize &raquo;</LinkButton>
  </ButtonSet>
</div>
}

export default BundleActions
